import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroSection from '@/pages/home/components/HeroSection';
import StatsStrip from '@/pages/home/components/StatsStrip';
import TopicCollections from '@/pages/home/components/TopicCollections';
import ReviewArchive from '@/pages/home/components/ReviewArchive';
import YearTimeline from '@/pages/home/components/YearTimeline';
import CommentWall from '@/pages/home/components/CommentWall';
import CategoryIndex from '@/pages/home/components/CategoryIndex';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main className="pt-[100px]">
        <HeroSection />
        <StatsStrip />
        <TopicCollections />
        <ReviewArchive />
        <YearTimeline />
        <CommentWall />
        <CategoryIndex />
      </main>
      <SiteFooter />
    </div>
  );
}